<script>
		import Adventure from "../prepare/Adventure.svelte";
		import Section from "../prepare/Section.svelte";
</script>


<!-------------------------------- HTML -------------------------------------->

<section>
	{#if !view.section}
		<Adventure />
	{:else}
		<Section />
	{/if}
</section>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	section
		grid-area: 1 / span 2
</style>